import React, {
  createContext,
  useContext,
  useLayoutEffect,
  useState,
} from 'react';
import { useLocation, useNavigate, createSearchParams } from 'react-router-dom';

const HouseOfferSearchParamsContext = createContext();

export const HouseOfferSearchParamsProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParamsState] = useState({});

  useLayoutEffect(() => {
    const params = new URLSearchParams(location.search);
    const parsed = {
      startDate: params.get('startDate') || null,
      endDate: params.get('endDate') || null,
      adults: params.get('adults') || null,
      children: params.get('children') || null,
      infants: params.get('infants') || null,
    };

    console.log('[HouseOfferSearchParams] ⏱️ Parsed from URL:', parsed);
    setSearchParamsState(parsed);
  }, [location.search]);

  const setSearchParams = (params) => {
    const filtered = Object.entries(params).reduce((acc, [key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {});

    const search = createSearchParams(filtered).toString();

    console.log('[HouseOfferSearchParams] 🔧 setSearchParams:', params);
    console.log('[HouseOfferSearchParams] 🚀 Navigating with:', search);

    navigate({ pathname: location.pathname, search: `?${search}` }, { replace: true });
  };

  const clearSearchParams = () => {
    console.log('[HouseOfferSearchParams] 🧹 Clearing searchParams');
    navigate({ pathname: location.pathname, search: '' }, { replace: true });
  };

  return (
    <HouseOfferSearchParamsContext.Provider
      value={{ searchParams, setSearchParams, clearSearchParams }}
    >
      {children}
    </HouseOfferSearchParamsContext.Provider>
  );
};

export const useHouseOfferSearchParams = () =>
  useContext(HouseOfferSearchParamsContext);
